export enum TypeOfPdf {
  ORDER = '1', // Pedido de Venda
  BUDGET = '2' // Orçamento
}

export enum TypeOfPdfSection {
  HEADER = '1', // Cabeçalho
  ITEMS = '2' // Items
}

export enum TypeOfPDFOperation {
  DETAILS = 2,
  ADD = 3,
  UPDATE = 4,
  DELETE = 5
}
